<script setup>
import { noImage } from '@/common/helper'
import { useCatalogState } from '../composables/CatalogState.js'
import { useUserInventory } from '../composables/UserInventory.js';
import Breadcrumbs from '@/components/Breadcrumbs.vue'

const {
  categoriesFiltered: categories,
  categoryBreadcrumbs: breadcrumbs,
  isDevelopmentMode,
  isRootCategory,
  hasPrivateTrays,
  categoryDesign,
  selectCategory,
} = useCatalogState();

const {
  showPrivateTrays,
} = useUserInventory();
</script>

<template>
  <!-- Categories -->
  <div>

    <!-- Breadcrumbs -->
    <div class="mt-6">
      <Breadcrumbs class="text-lg font-medium" :items="breadcrumbs" @click="(item) => selectCategory(item.id)" />
    </div>

    <!-- Category button container -->
    <div class="relative grid sm:grid-cols-2 lg:grid-cols-3 gap-4 w-full text-center mt-2 mb-2">

      <!-- Special category buttons for navigation -->
      <div class="grid grid-cols-2" v-if="!isRootCategory">

        <!-- Back to the root -->
        <a href="#" @click.prevent="selectCategory('_root')" class="p-0 mr-2 grid category-button special-button">
          <div class="grid place-items-center" style="height: 120px;">
            <div>
              <h3 class="mt-2 category-button-text"><i class="fa-solid fa-house"></i></h3>
              <h5 class="mt-4 mb-2 category-button-hint"><i class="fa fa-angles-left"></i> Na začetek</h5>
            </div>
          </div>
        </a>

        <!-- One step back -->
        <a href="#" @click.prevent="selectCategory(parentCategoryId)" class="p-0 ml-2 grid category-button special-button">
          <div class="grid place-items-center" style="height: 120px;">
            <div>
              <h3 class="mt-2 category-button-text"><i class="fa-solid fa-arrow-turn-up flip-x"></i></h3>
              <h5 class="mt-4 mb-2 category-button-hint"><i class="fa fa-angles-left"></i> Nazaj</h5>
            </div>
          </div>
        </a>

      </div>

      <!-- Special category button: private trays -->
      <div class="grid" v-if="isRootCategory && hasPrivateTrays">

        <!-- Private trays -->
        <a href="#" @click.prevent="showPrivateTrays()" class="p-0 grid category-button special-button">
          <div class="grid place-items-center" style="height: 120px;">
            <div>
              <h3 class="mt-2 category-button-text"><i class="fa-solid fa-user-shield"></i></h3>
              <h5 class="mt-4 mb-2 category-button-hint">Osebni predali</h5>
            </div>
          </div>
        </a>

      </div>

      <!-- Category buttons -->
      <template v-for="(item, i) in categories">
        <!-- class row-category -->
        <a href="#" v-if="categoryDesign == 1" @click.prevent="selectCategory(item.id)" class="p-0 grid category-button"
          :class="{ 'grid-cols-1': !item.smallImageUrl, 'grid-cols-2': item.smallImageUrl, 'category-button-background': isDevelopmentMode }">
          <!-- Trick to test if image loads -->
          <img alt="" :src="item.smallImageUrl" @error="noImage(item)" class="w-1 h-1 fixed load-image-test" style="top: -3000px; left: -3000px;" />
          <div class="w-full" v-if="item.smallImageUrl">
            <div class="w-full" style="height: 120px; padding: 10px;">
              <div class="category-image-placeholder w-full" style="height: 100px;" :style="'background: url(\'' + item.smallImageUrl + '\'); background-repeat:no-repeat; background-position: center center; background-size: contain;'"></div>
            </div>
          </div>
          <!-- <div class="w-full text-center aspect-square grid place-items-center p-3 rounded-md" v-if="item.smallImageUrl">
            <img :src="item.smallImageUrl" alt="" class="rounded-md" style="max-height: 120px;" />
          </div> -->
          <div class="grid place-items-center" style="height: 120px;">
            <div>
              <h3 class="mt-2 px-2 category-button-text-md" v-if="item.name.length > 30">{{ item.name }}</h3>
              <h3 class="mt-2 px-2 category-button-text" v-else>{{ item.name }}</h3>
              <h5 class="mt-4 mb-2 category-button-hint" v-if="!item.smallImageUrl">Prikaži artikle <i class="fa fa-angles-right"></i></h5>
            </div>
          </div>
        </a>

        <!-- Design 2 -->
        <a href="#" v-else-if="categoryDesign == 2" @click.prevent="selectCategory(item.id)" class="p-0 grid category-button relative">
          <div class="w-full absolute top-0 left-0 rounded-lg" v-if="item.smallImageUrl">
            <div class="w-full relative rounded-lg" style="height: 120px;">
              <div class="category-image-placeholder rounded-lg w-full" style="height: 120px;" :style="'background: url(\'' + item.smallImageUrl + '\'); background-repeat:no-repeat; background-position: center center; background-size: cover;'"></div>
              <div class="dark:bg-blue-900 dark:border-blue-700 dark:hover:border-blue-500 dark:hover:bg-blue-800 rounded-lg absolute right-0 top-0 w-full" style="height: 120px;
              background: linear-gradient(135deg, rgba(35,56,118,0.65) 0%, rgba(35,56,118,1) 70%);
              ">
              </div>
            </div>
          </div>
          <div class="grid place-items-center relative z-100" style="height: 120px;">
            <div>
              <h3 class="mt-2 px-2 category-button-text-md" v-if="item.name.length > 30">{{ item.name }}</h3>
              <h3 class="mt-2 px-2 category-button-text" v-else>{{ item.name }}</h3>
              <h5 class="mt-4 mb-2 category-button-hint" v-if="!item.smallImageUrl">Prikaži artikle <i class="fa fa-angles-right"></i></h5>
            </div>
          </div>
        </a>

        <!-- Design 3 -->
        <a href="#" v-else @click.prevent="selectCategory(item.id)" class="p-0 grid category-button relative w-full">
          <div class="w-full absolute top-0 left-0 rounded-lg w-[65%]" v-if="item.smallImageUrl">
            <div class="w-full relative rounded-lg" style="height: 120px;">
              <div class="category-image-placeholder rounded-lg w-full" style="height: 120px;" :style="'background: url(\'' + item.smallImageUrl + '\'); background-repeat:no-repeat; background-position: center center; background-size: cover;'"></div>
              <div class="dark:bg-blue-900 dark:border-blue-700 dark:hover:border-blue-500 dark:hover:bg-blue-800 absolute right-0 top-0 w-[100%]" style="height: 120px;
              background: linear-gradient(90deg, rgba(35,56,118,0) 0%, rgba(35,56,118,0.8) 70%, rgba(35,56,118,1) 100%);
              ">
              </div>
            </div>
          </div>
          <div class="grid place-items-center relative top-0 right-0 z-100 w-full" style="height: 120px;">
          </div>
          <div class="grid place-items-center absolute top-0 right-0 z-100 w-[50%]" style="height: 120px;">
            <div>
              <h3 class="mt-2 px-2 category-button-text-md" v-if="item.name.length > 30">{{ item.name }}</h3>
              <h3 class="mt-2 px-2 category-button-text" v-else>{{ item.name }}</h3>
              <h5 class="mt-4 mb-2 category-button-hint" v-if="!item.smallImageUrl">Prikaži artikle <i class="fa fa-angles-right"></i></h5>
            </div>
          </div>
        </a>

      </template>

    </div>

  </div>
</template>

<style scoped>

.category-button {
  @apply border rounded-lg shadow
    bg-white border-slate-300 hover:border-blue-600
    dark:bg-blue-900 dark:border-blue-700 dark:hover:border-blue-500 dark:hover:bg-blue-800;
}

.category-button.special-button {
  @apply border rounded-lg shadow
    bg-amber-100 border-slate-300 hover:border-blue-600
    dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700;
}

.category-button .category-button-text {
  @apply text-lg font-bold dark:text-white;
}

.category-button .category-button-text-md {
  @apply /* text-md */ font-bold dark:text-white;
}

.category-button .category-button-hint {
  @apply text-sm font-medium text-slate-700 uppercase dark:text-white;
}

.category-button-background {
  background: linear-gradient(300deg, rgba(254,243,199,1) 0%, rgba(255,255,255,1) 62%);
}
</style>